<template>
  <v-card
    :flat="flat"
    class="rounded-xl"
    width="100%">
    <v-card-title
      v-if="titulo"
      class="subtitle-1 font-weight-medium">
      <div class="titulo text-center">
        {{ titulo }}
      </div>
    </v-card-title>
    <v-card-text
      class="altura-firmas">
    </v-card-text>
    <v-divider
      v-if="mostrarLinea">
    </v-divider>
    <v-card-actions>
      <div
        class="firmas">
        <div class="subtitle-1">
          {{ nombre }}
        </div>
        <div class="caption">
          {{ subNombre }}
        </div>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ContenedorFirma',
  props: {
    titulo: {
      type: String,
      required: false,
    },
    nombre: {
      type: String,
      required: true,
    },
    subNombre: {
      type: String,
      required: false,
    },
    flat: {
      type: Boolean,
      required: false,
      default: true,
    },
    mostrarLinea: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.altura-firmas {
  min-height: 80px
}
.titulo, .firmas {
  width: 100%;
}
.firmas {
  position: relative;
  text-align: center;
  text-transform: uppercase;
}
.v-card__actions {
  height: 70px;
}
</style>
